import { Component } from '@angular/core'
import { SharedService } from '@flowaccount/landing'

@Component({
  selector: 'flowaccount-dac-vdo-event',
  templateUrl: './dac-vdo-event.component.html',
  styleUrls: ['./dac-vdo-event.component.scss'],
})
export class DacVdoEventComponent {
  public videoList = [
    {
      videoId: '-bpJZPJOIUo',
      imageBaseName: 'DigitalAccounting',
      textKey: 'EVENT.DIGITAL_ACCOUNTING_CONFERENCE.VOD_EVENT.VDO.1.TEXT',
    },
    {
      videoId: 'zpxxSGiMzwA',
      imageBaseName: 'Expo',
      textKey: 'EVENT.DIGITAL_ACCOUNTING_CONFERENCE.VOD_EVENT.VDO.2.TEXT',
    },
  ]

  constructor(private sharedService: SharedService) {}

  linkVideo(youtubeURL: string) {
    return this.sharedService.openVideoTutorialModal(youtubeURL)
  }
}
